import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarMasculino from "../assets/images/perfumes.jpeg";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Perfumes() {
  useTrackPageView();
  useTimeOnPage();

  const handleWhatsappClick = async () => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "leads",
      category: "whatsapp",
      action: "click",
      label: "geral_cta_main",
    });

    await trackEvent("whatsapp_click", {
      buttonLocation: "masculino_cta_main",
    });

    window.open("https://midiapromo.com/zap/promosclubeperfume", "_blank");
  };

  return (
    <LandingCategory
      avatar={avatarMasculino}
      titleTop="CHEGA DE PAGAR"
      titleBottom="CARO EM PERFUMES!"
      highlightWord="EM PERFUMES!"
      members="20.000"
      description="Receba as melhores promoções de perfumes ORIGINAIS todos os dias! 🔥"
      whatsappLink="https://midiapromo.com/zap/promosclubeperfume" 
      telegramLink="https://t.me/seu-link"
      theme={themes.masculino}
      onWhatsappClick={handleWhatsappClick}
    />
  );
}